export const DEDICATED_FIELD_COST_MODE = 'dedicated_field_cost';

const optionalPricingKeys = [
  'affiliationPricingMode',
  'pricingAffiliationId',
  'pricingParticipantCount'
];

const positiveInteger = value => {
  if (value === null || value === undefined || value === '') return null;
  const number = Number(value);
  return Number.isInteger(number) && number > 0 ? number : null;
};

export const normalizeBookingPricingFields = bookingData => {
  const payload = {...bookingData};
  const mode = payload.affiliationPricingMode;

  if (mode === null || mode === undefined || mode === '') {
    optionalPricingKeys.forEach(key => delete payload[key]);
    return payload;
  }

  if (mode !== DEDICATED_FIELD_COST_MODE) {
    throw new Error('invalid_booking_pricing');
  }

  const affiliationId = positiveInteger(payload.pricingAffiliationId);
  const participantCount = positiveInteger(payload.pricingParticipantCount);
  if (!affiliationId || !participantCount || participantCount > 4) {
    throw new Error('invalid_booking_pricing');
  }

  payload.pricingAffiliationId = affiliationId;
  payload.pricingParticipantCount = participantCount;
  return payload;
};

const bookingErrorMessages = {
  invalid_request: 'BOOKING_REQUEST_INVALID',
  invalid_booking_pricing: 'BOOKING_REQUEST_INVALID',
  not_enough_credit: 'NOT_ENOUGH_CREDIT',
  old_slot: 'BOOKING_EVENT_HAS_PASSED',
  slot_already_booked: 'EVENT_ALREADY_BOOKED',
  slot_too_long: 'SLOT_TOO_LONG'
};

export const bookingErrorMessage = response => {
  const code = response && response.json && typeof response.json.error === 'string'
    ? response.json.error
    : null;
  return bookingErrorMessages[code] || 'BOOKING_REQUEST_FAILED';
};
